import {
  // Achyuth_Mohan,
  // Adam,
  // George_Sabu,
  // Hanna_Salam,
  // Jeswin,
  // Arathy_Sha_A,
  // Mrinalini_Nair_Ani,
  // Nayana_Vinod,
  Neha_Mariam_Mathew,
  // Snehal_Sha,
  Sony_P,
  // Sony_Thomas,
  hanna,
  jeswin,
  sony,
  arathy,
  vignesh,
  subru,
  arpitha,
  alaka,
  alex,
  adil,
  // neha,
} from "../assets/team/teamImages";

const coreData = [
  {
    id: 1,
    name: "Sony P",
    title: "Faculty Advisor",
    image: Sony_P,
    linkedIn: "",
  },
  {
    id: 2,
    name: "Hanna Salam",
    title: "Chairperson",
    image: hanna,
    linkedIn: "https://www.linkedin.com/in/hanna-salam/",
  },
  {
    id: 3,
    name: "Jeswin Thomas",
    title: "Vice-Chairperson",
    image: jeswin,
    linkedIn: 'https://www.linkedin.com/in/jeswin-thomas-/',
  },
  {
    id: 4,
    name: "Vignesh S Naik ",
    title: "CP Lead",
    image: vignesh,
    linkedIn: "https://www.linkedin.com/in/naik-ji/",
  },
  {
    id: 5,
    name: "Arathy Sha A",
    title: "Events Lead",
    image: arathy,
    linkedIn: "https://www.linkedin.com/in/arathy-sha-a-007611203/",
  },
  {
    id: 6,
    name: "Subramani E",
    title: "Tech Lead",
    image: subru,
    linkedIn: "https://www.linkedin.com/in/subramani-e/",
  },
  {
    id: 7,
    name: "Arpitha Sudhir",
    title: "Outreach Lead",
    image: arpitha,
    linkedIn: "https://www.linkedin.com/in/arpitha-sudhir-989b14221/",
  },
  {
    id: 8,
    name: "Adil Naz Muhammed",
    title: "Operations Head",
    image: adil,
    linkedIn: "https://www.linkedin.com/in/adilnazmo/",
  },
  {
    id: 9,
    name: "Neha Mariam Mathew",
    title: "Content Lead",
    image: Neha_Mariam_Mathew,
    linkedIn: "https://www.linkedin.com/in/neha-mariam-mathew-152a60239/",
  },
  {
    id: 10,
    name: "Alaka AJ",
    title: "Design Lead",
    image: alaka,
    linkedIn: "https://www.linkedin.com/in/alaka-aj/",
  },
  {
    id: 11,
    name: "Alex Mathew Biju",
    title: "Community Lead",
    image: alex,
    linkedIn: "https://www.linkedin.com/in/alex-mathew-7951a0256/",
  },
  {
    id: 12,
    name: "Sony Thomas",
    title: "Inclusivity Lead",
    image: sony,
    linkedIn: "https://www.linkedin.com/in/njansony/",
  },
];

export default coreData;
